import { Grid2,Typography,Paper,InputBase,List,ListItem,ListItemText } from "@mui/material"
import { useState,useEffect } from "react"
import { useNavigate } from "react-router-dom"
import Styles from "./Web.module.css"
import faq1 from "../../../ui-utils/latestPics/faq1.svg"
import faq2 from "../../../ui-utils/latestPics/faqMan.svg"
import faq3 from "../../../ui-utils/latestPics/faqQM.svg"
import button from "../../../ui-utils/latestPics/faqButton.svg"
import axios from "axios"
import {backendHosts} from "../../../ui-utils/apiConfig"
import DocumentMeta from 'react-document-meta'

const meta = {
    title: 'FAQs | Answers on Trading, Demat & Investments | TradeBoss',
    description: 'Find quick answers to all your TradeBoss trading & demat queries. Explore FAQs to trade confidently and manage your investments with ease.',
    canonical: 'https://tradeboss.co/support/faqs',
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'tradeboss faqs, stock trading FAQs, demat account FAQs, questions about brokerage, common trading questions, how does demat work, trading account queries'
        }
    }
}
function slugify(title) {
    return title
        .toLowerCase()
        .replace(/[^\w\s-]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-+|-+$/g, "");
}
export default function FaqWeb(){
    const [searchTerm, setSearchTerm] = useState("")
    const [suggestions, setSuggestions] = useState([])

    const history = useNavigate()

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            if (searchTerm.trim().length > 2) {
                fetchFaqSuggestions(searchTerm)
            } else {
                setSuggestions([])
            }
        }, 300)

        return () => clearTimeout(delayDebounce)
    }, [searchTerm])

    const fetchFaqSuggestions = async (tag) => {
        try {

            const res = await axios.get(`${backendHosts.ADMIN}/api/faqs/tags/search?tag=${tag}`)
            // const res = await httpRequest({
            //     endPoint: `/api/faqs/tags/search?tag=${tag}`,
            //     method: "get",
            //     instance: "instanceFive"
            // })

            if (res.data.status === 200) {
                setSuggestions(res.data?.data || [])
            }
        } catch (error) {
            console.error("Search error:", error)
        }
    }

    const handleFaqClick = (faq) => {
        const name = slugify(faq.category.name)
        const subCategory = slugify(faq.subcategory.name)
        const question = slugify(faq.question)

        setSuggestions([]);
        setSearchTerm('');
        // localStorage.setItem("category", faq.category.name);
        // localStorage.setItem("subcategoryId", faq.subcategory_id)
        localStorage.setItem("categoryId", faq.category_id)

        history( `/support/faqs/${name}/${subCategory}/${question}`,{
            state: { searchCategoryId: faq.category_id, searchSubCategoryId: faq.subcategory_id, searchFaqId: faq.id }
        })
    }

    return(
        <>
        <Grid2 className={Styles.outerCard}>
        <DocumentMeta {...meta} />
           <img src={faq1} alt="faq1" className={Styles.pic1} />
            <Grid2 className={Styles.innerCard}>
                <Grid2>
                        <img src={faq2} alt="faq2" className={Styles.pic2} />
                </Grid2>

                    <Grid2 className={Styles.middleCard}>
                        {/* <Typography className={Styles.heading}>
                            Frequently Asked Questions
                    </Typography> */}
                    <div className={Styles.headingContainer}>
                            <div className={Styles.gradientBackground}></div>
                            <Typography className={Styles.heading}>
                                Frequently Asked Questions
                            </Typography>
                          </div>
                        <Grid2 className={Styles.fieldCard}>
                            <Paper component="form" className={Styles.mobilefield}>
                                {/* <Typography className={Styles.preMobile}>91</Typography> */}

                                <InputBase
                                    className={Styles.inputbase}
                                    placeholder="Search"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                <img src={button} alt="faq2" className={Styles.button} />
                            </Paper>
                            {suggestions.length > 0 && (
                                <List
                                    className={Styles.searchCard}

                                >
                                    {suggestions.map((faq) => (
                                        <ListItem
                                            key={faq.id}
                                            button
                                            onClick={() => handleFaqClick(faq)}
                                        >
                                            <ListItemText primary={faq.question} />
                                        </ListItem>
                                    ))}
                                </List>
                            )}

                        </Grid2>

                 </Grid2>
                    <Grid2>
                        <img src={faq3} alt="faq2" className={Styles.pic3} />
                    </Grid2>
           </Grid2>
        </Grid2>
        </>
    )
}